import {
    URLAPI,
    ZONES_PATH,
    ZONE_CREATE_PATH,
    ZONE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_zones: {
        data: [],
        status: 0,
        message: {},
    },

    _create_zone: {
        data: {},
        status: 0,
        message: {},
    },
    _update_zone: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_ZONES = "GET_ALL_ZONES";
export const CREATE_ZONE = "CREATE_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";

export const zones_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_ZONES:
            return {
                ...state,
                _get_all_zones: action.payload,
            };
        case CREATE_ZONE:
            return {
                ...state,
                _create_zone: action.payload,
            };
        case UPDATE_ZONE:
            return {
                ...state,
                _update_zone: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllZones = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ZONES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_ZONES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_ZONES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_ZONES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createZone = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${ZONE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_ZONE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_ZONE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_ZONE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateZone = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${ZONE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_ZONE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_ZONE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ZONE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_zones = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
